import { createSlice } from '@reduxjs/toolkit';
import { IColor } from '../../interfaces';
import { IconBackgroundType } from '../../enums/IconBackgroundType';

import { getFromSessionStorage, saveToSessionStorage } from '../storage';
import { restoreFromDeepLink } from '../../domain/deep-link-provider';

export interface IFormState{
    strokeWidth: number,
    strokeColor: IColor,
    hasStroke: boolean,

    fillColor: IColor,
    hasFill: boolean,

    backgroundColor: IColor,
    backgroundType: IconBackgroundType,

    rotation: number,
    scale: number,

    // filters
    sharpness: number,
    smoothness: number,

    // search icons popup
    searchTerm: string,
}

export const formDefaults: IFormState = {
    strokeWidth: 1,
    strokeColor: {
        r: 1,
        g: 1,
        b: 1,
        a: 1,
    },
    hasStroke: true,

    fillColor: {
        r: 255,
        g: 255,
        b: 255,
        a: 1,
    },
    hasFill: false,

    backgroundColor: {
        r: 255,
        g: 255,
        b: 255,
        a: 1,
    },
    backgroundType: IconBackgroundType.Circle,

    rotation: 0,
    scale: 0.8,

    // filters
    sharpness: 0,
    smoothness: 0,

    // search icons popup
    searchTerm: '',
};

const copy = {...formDefaults};

// try to get data from session storage
const savedData = getFromSessionStorage();

copy.strokeWidth = (Number(savedData?.strokeWidth) || 0) || copy.strokeWidth;
copy.strokeColor = savedData?.strokeColor || copy.strokeColor;
copy.hasStroke = savedData?.hasStroke || copy.hasStroke;
copy.fillColor = savedData?.fillColor || copy.fillColor;
copy.hasFill = savedData?.hasFill || copy.hasFill;

copy.backgroundColor = savedData?.backgroundColor || copy.backgroundColor;
copy.backgroundType = savedData?.backgroundType || copy.backgroundType;

copy.rotation = (Number(savedData?.rotation) || 0) || copy.rotation;
copy.scale = (Number(savedData?.scale) || 0) || copy.scale;

copy.sharpness = (Number(savedData?.sharpness) || 0) || copy.sharpness;
copy.smoothness = (Number(savedData?.smoothness) || 0) || copy.smoothness;

restoreFromDeepLink(copy, null);

/**
 * initial state
 */
const initialState: IFormState = {
    strokeWidth: copy.strokeWidth,
    strokeColor: copy.strokeColor,
    hasStroke: copy.hasStroke,

    fillColor: copy.fillColor,
    hasFill: copy.hasFill,

    backgroundColor: copy.backgroundColor,
    backgroundType: copy.backgroundType,

    rotation: copy.rotation,
    scale: copy.scale,

    // filters
    sharpness: copy.sharpness,
    smoothness: copy.smoothness,

    // search icons popup
    searchTerm: '',
};

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {

        main(state, action) {

            const updated = {
                ...state,
                ...action.payload,
            };

            // save to the session storage for the future use
            saveToSessionStorage(updated);

            return updated;
        },
    }
});

export default formSlice;